'use strict';

module.exports = require('react').PropTypes;



//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react/static-7.33/prop-types.js
// module id = 29
// module chunks = 171 172